import { toISOStringWithoutTimezone } from '@systemeio/ui'
import { getToday } from 'shared/utils/get-dates'
import { AvailabilitySlot, WeekdaysBackendEnum } from '../availability/types/availability-interface'

export const sortWeekdaySlots = (weekdaySlots: AvailabilitySlot[]) => {
  return weekdaySlots.sort((prev, curr) => {
    if (
      prev.startTime === null ||
      prev.endTime === null ||
      curr.startTime === null ||
      curr.endTime === null
    )
      return 1

    // compare startTimes first
    if (prev.startTime !== curr.startTime) {
      return prev.startTime - curr.startTime
    }

    // if startTimes are the same, compare endTimes
    return prev.endTime - curr.endTime
  })
}

export const getDateOnly = (dateTime: string) => {
  return dateTime.split('T')[0]
}

export const getWeekdayShortLocoKey = (weekday: WeekdaysBackendEnum) => {
  return `global.day_of_week_short.${weekday.toLocaleLowerCase()}`
}

export const getMonthStartEndDates = (date: Date) => {
  const startDate = toISOStringWithoutTimezone(
    new Date(date.getFullYear(), date.getMonth(), 1),
  ).slice(0, 10)

  const endDate = toISOStringWithoutTimezone(
    new Date(date.getFullYear(), date.getMonth() + 1, 0),
  ).slice(0, 10)

  return { startDate, endDate }
}

const MS_IN_30_DAYS = 2592000000 // 30 * 24 * 60 * 60 * 1000

export const getDateAfter30Days = () => {
  return getDateOnly(new Date(getToday().getTime() + MS_IN_30_DAYS).toISOString())
}

export const shortDateToGreenwichLongDate = (date: string) => {
  return `${date}T00:00:00+00:00`
}
